"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Presets_1 = tslib_1.__importDefault(require("./Presets"));
/*
 * @internal
 *
 * Figure out which preset to use based on the key in the Presets object
 * It's important that the keys in the presets identifies the start of
 * the window.location.host
 *
 * @param url - This should be window.location.host
 * @returns The found preset, or defaults to "argusweb"
 */
function presetFromUrl(url) {
    for (const key in Presets_1.default) {
        if (url.startsWith(key)) {
            return key;
        }
    }
    return "argusweb";
}
exports.default = presetFromUrl;
